import React, { useEffect, useRef, useCallback } from "react";
import { toast, ToastContainer } from "react-toastify";
import Select from "react-select";
// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams, useHistory } from "react-router-dom";
import { proformaAdded } from "../../Redux/proformaReduce";
import { useTranslation } from "react-multi-lang";
import { useDispatch } from "react-redux";
import { verification } from "../../Redux/usersReduce";
import { fetchGrossisteClient } from "../../Redux/grossisteReduce";
import { fetchGrossisteCommande } from "../../Redux/commandeReduce";
import Swal from 'sweetalert2';


function AjouterProforma({ client }) {
  const dispatch = useDispatch();
  const location = useParams();
  const navigate = useHistory();
  const t = useTranslation();
  const annee = localStorage.getItem("annee");
  const [loader, setLoader] = React.useState(false);

  if (isNaN(location.id) === true) document.title = t("Proforma.add");

  // State
  const [proforma, setProforma] = React.useState(null);
  const [reste, setReste] = React.useState(null);
  const [numCmd, setNumCmd] = React.useState(null);
  const [clientNom, setClientNom] = React.useState(null);
  const [optionGrossiste, setOptionGrossiste] = React.useState([]);
  const [optionCommande, setOptionCommande] = React.useState([]);
  const [date, setDate] = React.useState(null);
  const [commandeFiles, setCommandeFiles] = React.useState([]);

  // Toast helper
  const notify = (type, msg) => {
    if (type === 1) toast.success(<strong>{msg}</strong>);
    else toast.error(<strong>{msg}</strong>);
  };

  // Récupérer la liste des grossistes
  const getGrossiste = useCallback(async () => {
    const type = await dispatch(fetchGrossisteClient({ id_site: client == "/medis" ? 2 : 3 }));
    const entities = type.payload;
    const arrayOption = entities.map((e) => ({
      value: e.id_grossiste,
      label: e.code + ":" + e.raison_sociale,
      raison_sociale: e.raison_sociale,
      code: e.code,
    }));
    setOptionGrossiste(arrayOption);
  }, [dispatch, client]);

  // Récupérer commandes par client
  const getCommande = useCallback(
    async (code_client, client, annee) => {
      const type = await dispatch(fetchGrossisteCommande({ code_client, client, annee }));
      const entities = type.payload;
      const arrayOption = entities.map((e) => ({
        value: e.numero,
        label: e.numero,
        id: e.id,
        proforma: e.proforma,
      }));
      setOptionCommande(arrayOption);
    },
    [dispatch]
  );

  // Soumission du formulaire
  const isSubmitting = useRef(false);

  const submitForm = async () => {
    if (isSubmitting.current) return; // empêche le double submit

    if (!date || !clientNom) {
      toast.warning("Veuillez remplir tous les champs obligatoires !");
      return;
    }
    for (const f of commandeFiles) {
      if (!f.numCmd) {
        toast.error("Chaque ligne doit avoir un numéro de facture et un fichier !");
        return;
      }
    }

    const formData = new FormData();
    formData.append("date", date);
    if (reste) formData.append("reste", reste);
    formData.append("client", client);
    formData.append("clientNom", clientNom?.raison_sociale || "");
    formData.append("id_grossiste", clientNom?.value || "");
    formData.append("clientCode", clientNom?.code || "");
    var commandesNonProforma = []
    commandeFiles.forEach((f, index) => {
      formData.append(`proformas`, f.file);
      formData.append(`numCmd[${index}]`, f.numCmd.value);
      formData.append(`idCmd[${index}]`, f.numCmd.id);
      formData.append(`proformaCmd[${index}]`, f.numCmd.proforma);
      if (f.numCmd.proforma == 0) {
        commandesNonProforma.push(f.numCmd.value)
      }
    });

    try {
      let continuerSave = 0;
      const resultSwal = await Swal.fire({
        title: 'Commandes sans proforma détectées',
        text: commandesNonProforma.length > 0
          ? `Les commandes suivantes n’ont pas de proforma : ${commandesNonProforma.join(', ')}`
          : "Voulez-vous continuer ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui',
        cancelButtonText: 'Non',
      });

      if (resultSwal.isConfirmed) {
        continuerSave = 1;
      }

        setLoader(true);
      if (continuerSave == 1) {
        isSubmitting.current = true;
        const result = await dispatch(proformaAdded(formData));
        if (result.payload && result.payload.files) {
          toast.success("Fichiers enregistrés avec succès !");
          setTimeout(() => {
            window.location.replace(client + "/listProforma")
          }, 800);
        } else {
          isSubmitting.current = false;
          toast.error("Impossible de récupérer les fichiers enregistrés.");
        }
      }
    } catch (error) {
      isSubmitting.current = false;
      toast.error("Erreur lors de l'enregistrement des fichiers.");
    } finally {
      setLoader(false);
    }

  };

  // Dynamic rows handlers
  const addRow = () => {
    setCommandeFiles([...commandeFiles, { numCommande: null, file: null }]);
  };

  const removeRow = (index) => {
    const newCommandeFiles = [...commandeFiles];
    newCommandeFiles.splice(index, 1);
    setCommandeFiles(newCommandeFiles);
  };

  const handleNumCommandeChange = (index, value) => {
    const newCommandeFiles = [...commandeFiles];
    newCommandeFiles[index].numCmd = value;
    setCommandeFiles(newCommandeFiles);
  };

  const handleFileChange = (index, file) => {
    const newCommandeFiles = [...commandeFiles];
    newCommandeFiles[index].file = file;
    setCommandeFiles(newCommandeFiles);
  };

  // Vérification du token
  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then((e) => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      });
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }
  }, [dispatch]);

  // Upload fichiers
  const handleUploadFile = (event) => {
    let blFile = event.target.files[0];
    if (blFile) setProforma(blFile);
  };

  const handleUploadFileReste = (event) => {
    let blFile = event.target.files[0];
    if (blFile) setReste(blFile);
  };

  useEffect(() => {
    verifToken();
    getGrossiste();
  }, [location.id, dispatch, navigate, getGrossiste, verifToken]);

  function listeProforma() {
    navigate.push(client + "/listProforma");
  }

  return (
    <>
      <Container fluid>
        <ToastContainer />
        <div className="section-image">
          <Row>
            <Col md="12">
              <Button
                id="saveBL"
                className="btn-wd btn-outline mr-1 float-left"
                type="button"
                variant="info"
                onClick={listeProforma}
              >
                <span className="btn-label">
                  <i className="fas fa-list"></i>
                </span>
                {t("list")}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Form className="form">
                <Card>
                  <Card.Header>
                    <Card.Title as="h4">
                      Ajout Proforma / Reste à livrer
                    </Card.Title>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col md="6">
                        <Form.Group>
                          <label>Client *</label>
                          <Select
                            placeholder="Client"
                            className="react-select"
                            value={clientNom}
                            onChange={(value) => {
                              setClientNom(value);
                              setCommandeFiles(prev =>
                                prev.map(row => ({
                                  ...row,
                                  numCmd: null
                                }))
                              );
                              setOptionCommande({})
                              getCommande(value.code, client, annee);
                            }}
                            options={optionGrossiste}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <br></br>
                    <Row>
                      <Col md="6">
                        <Form.Group>
                          <label>Date d'enlevement *</label>
                          <Form.Control
                            value={date || ""}
                            placeholder="Date"
                            type="date"
                            onChange={(e) => setDate(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <h5 className="text-left font-bold">Reste à livrer</h5>
                        <Form.Group>
                          <Form.Control
                            type="file"
                            accept="application/pdf"
                            onChange={handleUploadFileReste}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <br></br>
                    <Row>
                      <Col md="12">
                        <h5>Proforma et fichiers</h5>
                        {commandeFiles.map((item, index) => (
                          <Row key={index} className="mb-2 align-items-center">
                            <Col md="5">
                              <Select
                                placeholder="Commande"
                                className="react-select"
                                value={item.numCmd}
                                onChange={(value) => handleNumCommandeChange(index, value)}
                                options={optionCommande}
                              />
                            </Col>
                            <Col md="5">
                              <Form.Control
                                type="file"
                                accept="application/pdf"
                                onChange={(e) => handleFileChange(index, e.target.files[0])}
                              />
                            </Col>
                            <Col md="2">
                              <Button variant="danger" onClick={() => removeRow(index)}>
                                Supprimer
                              </Button>
                            </Col>
                          </Row>
                        ))}
                        <Button variant="info" onClick={addRow}>
                          Ajouter une ligne
                        </Button>
                      </Col>
                    </Row>

                    {!loader ? (
                      <Button
                        className="btn-fill pull-right"
                        type="button"
                        variant="info"
                        onClick={submitForm}
                      >
                        {t("save")}
                      </Button>
                    ) : (
                      <div className="pull-right text-info font-weight-bold">
                        ⏳ Enregistrement en cours...
                      </div>
                    )}

                    <div className="clearfix"></div>
                  </Card.Body>
                </Card>
              </Form>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
}

export default AjouterProforma;
